import React, { useState } from "react";
import { Box, CssBaseline, Grid } from "@mui/material";
import { Button, Typography, IconButton } from "@mui/material";
import logoImage from "../../../assets/images/logoblue.png";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useAuth } from "../../../hooks";
import { Toast } from "../../../common/alert";
import { useContributorsContext } from "../../../providers/OrganizationAdmin/ContributorsProvider";
import { showNotification } from "../../../constants";
function ResetPassword() {
  const { setLoading, loading } = useContributorsContext();

  const { currentUser } = useAuth();
  console.log("currentUser", currentUser);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [resetPassword, setResetPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    // setResetPassword(event.target.value);
  };
  const handlePasswordedChange = (event) => {
    // setPassword(event.target.value);
    setResetPassword(event.target.value);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  // const handleSubmit = (event) => {
  //   event.preventDefault();
  //   console.log("Submit data", handleSubmit);
  // };
  const handleSubmit = async () => {
    try {
      setLoading(true);

      // Check if the passwords match
      if (password !== resetPassword) {
        setError("Passwords do not match");
        return;
      }
      // const auth = getAuth();
      // const user = auth.currentUser;
      // await updatePassword(user, password, resetPassword);

      // Show success message
      // Toast("success", "User password updated successfully");
      showNotification("User password updated successfully");
    } catch (error) {
      // Handle error
      Toast("error", `Error updating user password ${error.message}`);
      console.error("Error updating user password", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        paddingBottom: "20px",
      }}
    >
      <CssBaseline />
      <Grid
        container
        direction="column"
        alignItems="center"
        spacing={2}
        maxWidth="336px"
      >
        <Grid item>
          <img
            src={logoImage}
            alt="Logo"
            style={{ width: "335.99px", height: "86px", color: "#00A7CD" }}
          />
        </Grid>

        <Grid
          item
          display={"flex"}
          flexDirection="column"
          gap={"4px"}
          spacing={2}
          width="100%"
        >
          <Typography style={{ fontSize: "18px", fontWeight: 700 }}>
            Reset Password
          </Typography>
          <Typography>Password</Typography>
          <div style={{ position: "relative", width: "100%" }}>
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={handlePasswordChange}
              placeholder="Enter your password"
              style={{
                width: "100%",
                height: "48px",
                borderRadius: "8px",
                border: "1px solid #00A7CD",
                padding: "12px",
              }}
            />
            <div
              style={{
                position: "absolute",
                top: "42%",
                right: "13px",
                transform: "translateY(-50%)",
              }}
            >
              <IconButton onClick={togglePasswordVisibility} edge="end">
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </div>
          </div>
        </Grid>
        <Grid
          item
          display={"flex"}
          flexDirection="column"
          gap={"4px"}
          spacing={2}
          width="100%"
        >
          <Typography>Re-Enter Password</Typography>
          <div style={{ position: "relative", width: "100%" }}>
            <input
              type={showPassword ? "text" : "password"}
              value={resetPassword}
              onChange={handlePasswordedChange}
              placeholder="Enter your reset password"
              style={{
                width: "100%",
                height: "48px",
                borderRadius: "8px",
                border: "1px solid #00A7CD",
                padding: "12px",
                marginBottom: "10px",
              }}
            />
            <div
              style={{
                position: "absolute",
                top: "42%",
                right: "13px",
                transform: "translateY(-50%)",
              }}
            >
              <IconButton onClick={togglePasswordVisibility} edge="end">
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </div>
          </div>
        </Grid>
        <Grid item width={"336px"}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            style={{
              width: "100%",
              height: "34px",
              borderRadius: "4px",
              backgroundColor: "#00A7CD",
            }}
          >
            Reset Password
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default ResetPassword;
